// Wenn du im Router <ChatGptApp /> verwendest
export const ChatGPTApp: React.FC = () => {
  return (
    <div className="p-6">
      <h1 className="text-xl font-semibold">ChatGPT Modul</h1>
      <p className="text-gray-500 mt-2">Hier entsteht die Integration.</p>
    </div>
  );
};
